<!--
  --
  -- データ要素コンポーネント
  --
  -->
<template>
  <div class="c-confirm-total-row text--primary">
    <!-- ラベル -->
    <div class="c-confirm-total-label">
      <span>{{label}}</span>
    </div>

    <!-- 料金 -->
    <div class="c-confirm-total-charge">
      <span>{{charge | comma}}</span>
      <small class="ml-2 text--secondary">円</small>
    </div>
  </div>
</template>

<style lang="scss">
.c-confirm-total-row {
  display: flex;
  flex-flow: row wrap;
  align-items: baseline;
  line-height: 1.5rem;

  .c-confirm-total-label {
    flex-grow: 1;
  }

  .c-confirm-total-charge {
    width: 5em;
    text-align: right;

    > span {
      font-size: 1rem;
    }
  }

  span {
    font-weight: bold;
  }
}
</style>

<script>
export default {
  name: 'CTotalRow',
  props: {
    // ラベル
    label: {
      type: String
    },

    // 金額
    charge: {
      type: Number
    }
  }
}
</script>
